/**
 * Created by m.igrachev on 7/6/2017.
 */
const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "true",
        description: "ControlMessageGroup component nests messages, so some children are expected."
    },
    {
        name: "expandable",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description:
            "If set to true will make the messages in the group expandable via expand icon."
    },
    {
        name: "closable",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true show close icon for the group."
    },
    {
        name: "reverseExpandDirection",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true will reverse the expand direction of the group."
    },
    {
        name: "icon",
        type: "String",
        defaultValue: "depends on type",
        isRequired: "false",
        description: "Can be used to provide custom icon for a Group."
    },
    {
        name: "name",
        type: "String",
        defaultValue: "false",
        isRequired: "false",
        description: "The name/title of the Group."
    },
    {
        name: "collapsedHint",
        type: "String",
        defaultValue: "false",
        isRequired: "false",
        description: "A hint to display when expandable Group is collapsed."
    },
    {
        name: "onToggleExpand",
        type: "Function",
        defaultValue: "false",
        isRequired: "false",
        description: "Callback to be executed when expand is invoked."
    },
    {
        name: "onClose",
        type: "Function",
        defaultValue: "false",
        isRequired: "false",
        description: "Callback to be executed when close is invoked."
    },
    {
        name: "groupType",
        type: '["error", "success", "warning", "info", "neutral"]',
        defaultValue: "error",
        isRequired: "false",
        description: "The type of the control message group."
    },
    {
        name: "skipName",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true will skip group's name. Usable in case of defaulting the name!"
    },
    {
        name: "skipAlertIcon",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true will skip group's icon."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be added to ControlMessageGroup."
    }
];

export default documentedProperties;
